module.exports = __webpack_public_path__ + "static/media/polinizador.65d4e91e.svg";